/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StaffMealRes } from './staffMealRes';
import { Merchant } from './merchant';
import { PaymentOrderItemRes } from './paymentOrderItemRes';
import { PaymentItemRes } from './paymentItemRes';
import { StaffRes } from './staffRes';
import { TableMerchant } from './tableMerchant';
import { Membership } from './membership';
import { PaymentMethod } from './paymentMethod';
import { Voucher } from './voucher';


export interface PaymentRes { 
    appliedMembershipPoint?: number;
    buzzerNo?: string;
    changeAmount?: number;
    chargesAmount?: number;
    createdByName?: string;
    creationTime?: string;
    deleted?: boolean;
    discountAmount?: number;
    discountBy?: string;
    discountItemAmount?: number;
    discountPercentage?: number;
    discountRemarks?: string;
    ewalletReferenceNo?: string;
    id?: number;
    inclusiveTax?: number;
    membership?: Membership;
    membershipPoint?: number;
    merchant?: Merchant;
    netAmount?: number;
    paidAmount?: number;
    paxNo?: number;
    paymentItems?: Array<PaymentItemRes>;
    paymentMethod?: PaymentMethod;
    paymentMethodUpdateRemark?: string;
    paymentMethodUpdatedAt?: string;
    paymentMethodUpdatedBy?: string;
    paymentNo?: string;
    paymentOrderItems?: Array<PaymentOrderItemRes>;
    paymentStatus?: PaymentRes.PaymentStatusEnum;
    previousPaymentMethod?: PaymentMethod;
    queueNo?: string;
    roundingAmount?: number;
    staffMeal?: StaffMealRes;
    staffMealAmount?: number;
    staffMealNewBalance?: number;
    staffMealPreviousBalance?: number;
    staffMealStaff?: StaffRes;
    tableId?: number;
    tableMerchant?: TableMerchant;
    tax1Amount?: number;
    tax2Amount?: number;
    tipsAmount?: number;
    totalAmount?: number;
    updateTime?: string;
    updatedByName?: string;
    voidDate?: string;
    voidRemark?: string;
    voidUser?: string;
    voucher?: Voucher;
    voucherAmount?: number;
    voucherCode?: string;
}
export namespace PaymentRes {
    export type PaymentStatusEnum = 'PAID' | 'UNPAID' | 'VOIDED';
    export const PaymentStatusEnum = {
        Paid: 'PAID' as PaymentStatusEnum,
        Unpaid: 'UNPAID' as PaymentStatusEnum,
        Voided: 'VOIDED' as PaymentStatusEnum
    };
}


